module.exports = __webpack_public_path__ + "img/1949-Groveland Four.ca0fefe4.jpg";